import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout, type RootState } from '@/store';
// import { setToken } from '@/store/slices/authSlice';
import { ApiResponse, AuthTokens } from '@/types';
import Cookies from 'js-cookie';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  credentials: 'include',
  // prepareHeaders: (headers, { getState }) => {
  //   // const token = Cookies.get('authToken');
  //   // const tempAuthToken = (getState() as RootState).auth.tempAuthToken;
  //   // const finalToken = token || tempAuthToken;
  //   // if (finalToken) {
  //   //   headers.set('authorization', `Bearer ${finalToken}`);
  //   // }
  //   // headers.set('content-type', 'application/json');
  //   return headers;
  // },
});

// const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
//   const result = await baseQuery(args, api, extraOptions);
//   if (result.error && result.error.status === 401) {
//     console.warn('Unauthorized! Logging out user...');
//     // Cookies.remove('authToken');
//     setTimeout(() => {
//       if (window.location.pathname === '/login') return;
//       window.location.href = '/login';
//     }, 1000);
//   }
//   return result;
// };

// let isRedirecting = false;

// const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
//   const result = await baseQuery(args, api, extraOptions);

//   // if (result.error?.status === 401 && !isRedirecting) {
//   //   isRedirecting = true;

//   //   console.warn('Unauthorized!');
//   //   // api.dispatch(logout());
//   //   api.dispatch({ type: 'auth/logout' });
//   //   api.dispatch(apiSlice.util.resetApiState());
//   //   window.location.replace('/login');
//   // }

//   return result;
// };
let isRedirecting = false;

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401 && !isRedirecting) {
    const errorData = result.error.data as any;

    const message = errorData?.message?.toLowerCase?.() || '';

    const shouldLogout =
      message.includes('unauthorized') ||
      message.includes('token') ||
      message.includes('expired') ||
      message.includes('login');

    if (shouldLogout) {
      isRedirecting = true;

      api.dispatch({ type: 'auth/logout' });

      api.dispatch(apiSlice.util.resetApiState());

      Cookies.remove('authToken');

      window.location.replace('/login');
    }
  }

  return result;
};
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  // baseQuery: baseQuery,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60,
  tagTypes: ['Auth', 'User', 'Event'],
  endpoints: () => ({}),
});

// Export hooks for usage in functional components
export const {
  util: { getRunningQueriesThunk },
} = apiSlice;

export default apiSlice;
